import { useQuery } from '@tanstack/react-query';

import { QUERY_DEFAULTS } from '@/shared/lib/constants/api';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { fetchDagDashboardListApi } from '@/entities/dag/api/fetchDagDashboardListApi';
import type { DagDashboardListParams, DagDashboardListResponse } from '@/entities/dag/domain/types';

export const useDagDashboardList = (params?: DagDashboardListParams) => {
  return useQuery<DagDashboardListResponse>({
    queryKey: dagKeys.dashboardList(params),
    queryFn: () => fetchDagDashboardListApi(params),
    staleTime: QUERY_DEFAULTS.STALE_TIME.SHORT,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
    retry: false,
  });
};
